(() => {
  if (customElements.get('main-blog-page')) return;

  class MainBlogPage extends HTMLElement {
    connectedCallback() {
      this.section_id = this.dataset.sectionId;
      this.tab_buttons = Array.from(this.querySelectorAll('[data-tab-target]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));

      if (!this.tab_buttons.length || !this.panels.length) return;

      this.default_tab = this.dataset.defaultTab || this.tab_buttons[0]?.dataset.tabTarget;
      this.bound_click = this.handle_tab_click.bind(this);
      this.bound_block_select = this.handle_block_select.bind(this);
      this.bound_section_load = this.handle_section_load.bind(this);

      this.tab_buttons.forEach((button) => {
        button.addEventListener('click', this.bound_click);
      });

      document.addEventListener('shopify:block:select', this.bound_block_select);
      document.addEventListener('shopify:section:load', this.bound_section_load);

      const active_button = this.tab_buttons.find(
        (button) => button.getAttribute('aria-selected') === 'true'
      );
      const initial_tab = active_button?.dataset.tabTarget || this.default_tab;
      this.set_active_tab(initial_tab);
    }

    disconnectedCallback() {
      if (!this.tab_buttons || !this.bound_click) return;

      this.tab_buttons.forEach((button) => {
        button.removeEventListener('click', this.bound_click);
      });

      document.removeEventListener('shopify:block:select', this.bound_block_select);
      document.removeEventListener('shopify:section:load', this.bound_section_load);
    }

    handle_tab_click(event) {
      const target = event.currentTarget?.dataset?.tabTarget;
      if (!target) return;
      this.set_active_tab(target);
    }

    handle_block_select(event) {
      if (!this.section_id || event.detail.sectionId !== this.section_id) return;

      const block_element = document.getElementById(`shopify-block-${event.detail.blockId}`);
      const tab_target = block_element?.dataset?.tabTarget;

      if (tab_target) {
        this.set_active_tab(tab_target);
      }
    }

    handle_section_load(event) {
      if (!this.section_id || event.detail.sectionId !== this.section_id) return;

      const active_button = this.tab_buttons.find(
        (button) => button.getAttribute('aria-selected') === 'true'
      );
      const initial_tab = active_button?.dataset.tabTarget || this.default_tab;
      this.set_active_tab(initial_tab);
    }

    set_active_tab(tab_key) {
      this.tab_buttons.forEach((button) => {
        const is_active = button.dataset.tabTarget === tab_key;
        button.setAttribute('aria-selected', is_active ? 'true' : 'false');
        button.tabIndex = is_active ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        const is_match = panel.dataset.panel === tab_key;
        panel.hidden = !is_match;
      });
    }
  }

  customElements.define('main-blog-page', MainBlogPage);
})();
